/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImpactLevelApi } from '../../sdk/services';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-link-impact-level-dialog',
  templateUrl: './link-impact-level-dialog.component.html',
  styleUrls: ['./link-impact-level-dialog.component.scss'],
})
export class LinkImpactLevelDialogComponent implements OnInit {
  initiatives: Array<any> = [];
  items: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LinkImpactLevelDialogComponent>,
    private ImpactLevelApi: ImpactLevelApi,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    // Fetch All Reporting Levels
    this.ImpactLevelApi.list().toPromise().then((response: any) => {
      this.initiatives = response.data;
    }).catch(this.notificationService.errorHandler);
  }

  confirmSelection() {
    this.dialogRef.close(this.initiatives);
  }

}
